// extracted by mini-css-extract-plugin
module.exports = {"container":"_6c97079b1b--container--ep-gH","link":"_6c97079b1b--link--2y0c1","mobile":"_6c97079b1b--mobile--L9ZmV"};